import { ArrowUpRight, Sparkles } from "lucide-react";
import { CATALOG, waLink } from "../../lib/site";

export const Catalog = () => {
  return (
    <section id="catalog" className="relative py-20 md:py-32 bg-cream overflow-hidden">
      <div
        className="absolute -left-20 top-20 w-[420px] h-[420px] opacity-[0.05] pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(124,95,171,0.6) 0%, transparent 70%)",
        }}
      />

      <div className="container-narrow relative">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20">
          <div className="max-w-xl">
            <span className="overline">Look Book</span>
            <h2 className="mt-3 font-serif text-4xl md:text-6xl text-ink leading-[1.05]">
              The <span className="italic text-garnet">Designer</span> edit.
            </h2>
            <p className="mt-6 text-muteink leading-relaxed max-w-md">
              A hand-picked selection of this season's couture sarees,
              photographed in our boutique. Tap any look to inquire — we'll
              share fabric, weave & price details on WhatsApp.
            </p>
          </div>

          <div className="flex">
            <a
              href={waLink("Hi! I'd like to inquire about a piece from your designer edit.")}
              target="_blank"
              rel="noreferrer"
              data-testid="catalog-whatsapp-btn"
              className="btn-primary"
            >
              <Sparkles size={16} />
              Inquire on WhatsApp
            </a>
          </div>
        </div>

        {/* Saree-only editorial grid */}
        <div className="grid grid-cols-12 gap-4 md:gap-6">
          {CATALOG.pages.map((src, i) => {
            const layouts = [
              "col-span-12 md:col-span-8 h-[280px] md:h-[420px]",
              "col-span-6 md:col-span-4 h-[280px] md:h-[420px]",
              "col-span-6 md:col-span-4 h-[280px] md:h-[380px]",
              "col-span-6 md:col-span-4 h-[280px] md:h-[380px]",
              "col-span-12 md:col-span-4 h-[280px] md:h-[380px]",
              "col-span-12 md:col-span-12 h-[280px] md:h-[440px]",
            ];
            return (
              <a
                key={i}
                href={waLink(`Hi! I'd like more details about Look ${String(i + 1).padStart(2, "0")} from your designer edit.`)}
                target="_blank"
                rel="noreferrer"
                data-testid={`catalog-page-${i + 1}`}
                className={`group relative overflow-hidden bg-sand/40 ${layouts[i]}`}
              >
                <img
                  src={src}
                  alt={`Designer look ${i + 1}`}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute top-4 left-4">
                  <span className="text-[10px] tracking-[0.25em] uppercase bg-cream/95 text-garnet px-3 py-1.5 backdrop-blur">
                    Look {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="absolute bottom-5 right-5 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <span className="inline-flex items-center gap-2 bg-gold text-ink px-4 py-2.5 text-[11px] tracking-[0.22em] uppercase">
                    Inquire <ArrowUpRight size={14} />
                  </span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Catalog;
